import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type OrderTimeCollectionState = string[];

export const ORDER_TIME_COLLECTION = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<OrderTimeCollectionState>
  >,
): ConditionType<OrderTimeCollectionState, Condition.OrderTimeCollection> => ({
  name: "Original collections at order time",
  description(state) {
    return `Original collections at order time: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<OrderTimeCollectionState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return model.collections;
  },
  toModel(state) {
    return { type: Condition.ORDER_TIME_COLLECTION, collections: state };
  },
  valid() {
    return true;
  },
});
